// =====================================
//
//   Order History Controller
//   Author: Gray
//   createtime: 2016 / 02 / 19
//   Author: Alan
//   updatetime: 2016 / 03 / 07
//
// =====================================
// order_history
window.InifECMobileApp.controller("OrderHistoryController", ['$scope', '$state', '$timeout', '$rootScope', 'UserService', 'OrderService', 'ShoppingCartService',
    function($scope, $state, $timeout, $rootScope, UserService, OrderService, ShoppingCartService) {

        var getOrderList = function() {
            
            if (!$scope.isLogin || $scope.isLoading || $scope.isNoMore || $scope.isEmpty) {
                return;
            }

            $scope.isLoading = true;
            OrderService.getOrderListWithStatus(700, $scope.start, $scope.len).then(function(result){
                if(Array.isArray(result) && result.length > 0) {
                    for(var i = 0 ; i < result.length ; i++){

                        var _order = result[i];

                        _order.timeMap = {};
                        
                        if(Array.isArray(_order.changelogs) && _order.changelogs.length > 0) {
                            // 分析change log並且
                            var changelogs = _order.changelogs;
                            for(var j = changelogs.length - 1 ; j >= 0 ; j--) {
                                var log = changelogs[j];
                                if(log.orderstatus == 0 || log.orderstatus == 202) {
                                    // 待審核
                                    if(!_order.timeMap[202]) {
                                        _order.timeMap[202] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 302) {
                                    // 審核中
                                    if(!_order.timeMap[302]) {
                                        _order.timeMap[302] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 303) {
                                    // 不合格
                                    if(!_order.timeMap[303]) {
                                        _order.timeMap[303] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 400) {
                                    // 完成付款
                                    if(!_order.timeMap[400]) {
                                        _order.timeMap[400] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 401) {
                                    // 待退貨
                                    if(!_order.timeMap[401]) {
                                        _order.timeMap[401] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 402) {
                                    // 已退貨
                                    if(!_order.timeMap[402]) {
                                        _order.timeMap[402] = log.updatetime;
                                    }
                                } else if(log.orderstatus >= 500 && log.orderstatus < 600) {
                                    // 商品製作中
                                    if(!_order.timeMap[500]) {
                                        _order.timeMap[500] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 600) {
                                    // 物流入庫（可取貨）
                                    if(!_order.timeMap[600]) {
                                        _order.timeMap[600] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 602) {
                                    // 貨物配送中
                                    if(!_order.timeMap[602]) {
                                        _order.timeMap[602] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 601) {
                                    // 物流入庫（待配送）
                                    if(!_order.timeMap[601]) {
                                        _order.timeMap[601] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 700) {
                                    // 物流入庫 or 貨物配送中
                                    if(!_order.timeMap[700]) {
                                        _order.timeMap[700] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 801) {
                                    // 人工退款中
                                    if(!_order.timeMap[801]) {
                                        _order.timeMap[801] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 802) {
                                    // 退款完成
                                    if(!_order.timeMap[802]) {
                                        _order.timeMap[802] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 803) {
                                    // 退貨審查失敗
                                    if(!_order.timeMap[803]) {
                                        _order.timeMap[803] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 804) {
                                    // 重印
                                    if(!_order.timeMap[804]) {
                                        _order.timeMap[804] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 805) {
                                    // 重印
                                    if(!_order.timeMap[805]) {
                                        _order.timeMap[805] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 806) {
                                    // 部分退款申請通過，待退款
                                    if(!_order.timeMap[806]) {
                                        _order.timeMap[806] = log.updatetime;
                                    }
                                } else if(log.orderstatus == 807) {
                                    // 已部分退款
                                    if(!_order.timeMap[807]) {
                                        _order.timeMap[807] = log.updatetime;
                                    }
                                }
                            }
                        }

                        _order.canRefund = false;


                        var paymentTime = _order.timeMap[700];

                        if(paymentTime) {
                            var now = Date.now();
                            var differ = now - paymentTime;
                            var timeago = differ / (60 * 60 * 24 * 1000);

                            if(timeago <= 2) {
                                _order.canRefund = true;
                            }
                        }

                        $scope.orders.push(_order);
                    }
                } else if ($scope.orders.length > 0) {
                    $scope.isNoMore = true;
                } else if ($scope.orders.length == 0) {
                    $scope.isEmpty = true;
                }

                $scope.start = $scope.start + $scope.len;
                $scope.isLoading = false;
            }, function(error) {
                $scope.isLoading = false;
                $scope.isError = true;
            });
        }

        var reOrder = function(event, order) {

            if(event) {
                event.stopPropagation();
                event.preventDefault();
            }

            if(order.isReOrdering){
                return;
            }

            order.isReOrderingError = false;
            order.isReOrderItemNotExist = false;
            order.isReOrdering = true;
            var orderid = order.orderid;
            ShoppingCartService.reOrderToShoppingCart(orderid).then(function(result) {
                if(result){
                    $state.go(window.STATES.CART);
                }else {
                    order.isReOrderingError = true;
                    order.isReOrdering = false;
                }                
            }, function(error){
                if(error && error.code == 'error.rscNotExist') {
                    order.isReOrderItemNotExist = true;
                } else {
                    order.isReOrderingError = true;
                }

                order.isReOrdering = false;
            });
        }

        var getDownloadUrl = function(url) {
            return url;
        }

        var getOrderCoverImage = function(order) {
            
            if(!order || !order.orderitems || order.orderitems.length == 0 || !order.orderitems[0].coverurl){
                return "about:blank";
            }

            return order.orderitems[0].coverurl.replace('medium', 'small');
        };

        var init = function() {
            $scope.isLoading = true;
            UserService.getUserInfo().then(function(result){
                $scope.isLoading = false;
                $scope.isLogin = true;

                getOrderList();
            }, function(error){
                $scope.isLoading = false;
            });           
        }

        //==========================
        //  Events
        //==========================
        

        //==========================
        //  Members
        //==========================
        $scope.state = $state.current.name;
        $scope.start = 0;
        $scope.len = 20;
        $scope.isLoading = false;
        $scope.isNoMore = false;
        $scope.isEmpty = false;
        $scope.isError = false;
        $scope.isLogin = false;
        $scope.orders = [];

        //==========================
        //  Methods
        //==========================
        $scope.getOrderList = getOrderList;
        $scope.reOrder = reOrder;
        $scope.getOrderCoverImage = getOrderCoverImage;

        //==========================
        //  Init
        //==========================

        init();

	}
]);